import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl} from "../Univ.js";
import {useNavigate} from "react-router-dom";
import "./IoTStyles.css";
function IoTDevices() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");
    const fetchDevices = async () => {
        try {
            setIsLoading(true);
            let url = baseUrl + "iot-devices/";
            if (search.trim() !== "") {
                url += "?search=" + encodeURIComponent(search);
            }
            const response = await axios.get(url);
            setRows(response.data);
        } catch (error) {
            console.log("IoT Device Error:", error);
            Swal.fire(
                "Error",
                "Unable to load IoT devices.",
                "error"
            );
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchDevices();
    }, []);
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete Device?",
            text: "This device will be removed from DrGHiS.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel"
        });
        if (!result.isConfirmed) {
            return;
        }
        try {
            await axios.delete(
                baseUrl + "iot-devices/" + id + "/"
            );
            Swal.fire(
                "Deleted",
                "Device has been deleted.",
                "success"
            );
            fetchDevices();
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to delete device.",
                "error"
            );
        }
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 70
        },
        {
            field: "device_id",
            headerName: "Device ID",
            width: 160
        },
        {
            field: "device_name",
            headerName: "Device",
            width: 190
        },
        {
            field: "device_type",
            headerName: "Type",
            width: 160
        },
        {
            field: "manufacturer",
            headerName: "Manufacturer",
            width: 160
        },
        {
            field: "model_number",
            headerName: "Model",
            width: 140
        },
        {
            field: "ip_address",
            headerName: "IP Address",
            width: 140
        },
        {
            field: "protocol",
            headerName: "Protocol",
            width: 120
        },
        {
            field: "ward",
            headerName: "Ward",
            width: 120
        },
        {
            field: "room",
            headerName: "Room",
            width: 120
        },
        {
            field: "bed",
            headerName: "Bed",
            width: 100
        },
        {
            field: "is_online",
            headerName: "Status",
            width: 110,
            renderCell: (params) => (
                params.value ?
                    <span className="iot-status online">
                        ONLINE
                    </span>
                    :
                    <span className="iot-status offline">
                        OFFLINE
                    </span>
            )
        },
        {
            field: "last_seen",
            headerName: "Last Seen",
            width: 190
        },
        {
            field: "actions",
            headerName: "Action",
            width: 260,
            sortable: false,
            renderCell: (params) => (
                <div className="iot-action-buttons">

                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                            navigate(
                                "/iot-device-form/" +
                                params.row.id
                            )
                        }
                    >
                        Edit
                    </button>


                    <button
                        className="btn btn-info btn-sm"
                        onClick={() =>
                            navigate(
                                "/iot-device-mapping/" +
                                params.row.id
                            )
                        }
                    >
                        Map
                    </button>


                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() =>
                            handleDelete(
                                params.row.id
                            )
                        }
                    >
                        Delete
                    </button>

                </div>
            )
        }
    ];
    return (
        <section className="container-fluid mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>
                        IoT Devices
                    </h3>

                    <p>
                        Manage medical and hospital IoT devices
                    </p>

                </div>


                <button
                    className="btn btn-success"
                    onClick={() =>
                        navigate("/iot-device-form/")
                    }
                >
                    + Add Device
                </button>

            </div>


            <div className="card shadow-sm mb-3">

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-8">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Device ID, Device, Manufacturer, Ward, Bed..."
                                value={search}
                                onChange={(e) =>
                                    setSearch(e.target.value)
                                }
                            />

                        </div>


                        <div className="col-md-2">

                            <button
                                className="btn btn-primary w-100"
                                onClick={fetchDevices}
                            >
                                Search
                            </button>

                        </div>


                        <div className="col-md-2">

                            <button
                                className="btn btn-secondary w-100"
                                onClick={() => {
                                    setSearch("");
                                    setTimeout(
                                        fetchDevices,
                                        100
                                    );
                                }}
                            >
                                Reset
                            </button>

                        </div>

                    </div>

                </div>

            </div>


            <div
                style={{
                    width: "100%"
                }}
            >

                <DataGrid

                    className="mt-3"

                    rows={rows}

                    columns={columns}

                    loading={isLoading}

                    autoHeight

                    pageSizeOptions={[
                        10,
                        25,
                        50,
                        100
                    ]}

                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 25,
                                page: 0
                            }
                        }
                    }}

                    slots={{
                        toolbar: GridToolbar
                    }}

                    sx={{
                        boxShadow: 3,
                        "& .MuiDataGrid-cell:hover": {
                            color: "primary.main"
                        }
                    }}

                />

            </div>

        </section>
    );
}
export default IoTDevices;
